import { defineStore } from 'pinia';
import { CanUseService, type Feature } from '@swpsoftware/commons-api/hey-mengencloud';

export const useFeatureStore = defineStore('Feature', {
  state: (): {
    features: Feature[];
  } => ({
    features: [],
  }),
  getters: {
    canWriteProjects: (state) => state.features.includes('Projects'),
    canWriteTemplates: (state) => state.features.includes('Templates'),
    canWriteCommonTemplates: (state) => state.features.includes('CommonTemplates'),
    canEditTexts: (state) => state.features.includes('Texts'),
  },
  actions: {
    async loadFeatures() {
      this.features = (await CanUseService.getFeatures()).data;
    },
    hasFeature(feature: Feature) {
      return this.features.includes(feature);
    },
  },
});
